import { AfterViewChecked, AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AjustageContexte as AjustageContexte } from 'src/app/domain/Shared/ajustage-context';
import { ControleConductiviteGroup } from 'src/app/domain/Shared/controle-conductivite-groupe';
import { EMasterSondeType } from 'src/app/domain/Shared/enum/master-sonde-type';
import { MasterSonde } from 'src/app/domain/Shared/master-sonde';
import { AjustageContexteService } from 'src/app/services/ajustage-context.service';
import { MasterSondeService } from 'src/app/services/master-sonde.service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { ConductiviteCalibrationBoxComponent } from 'src/app/tools/ui/conductivite-calibration-box/conductivite-calibration-box.component';
import { HistoryBoxComponent } from 'src/app/tools/ui/history-box/history-box.component';
import { OxygeneCalibrationBoxComponent } from 'src/app/tools/ui/oxygene-calibration-box/oxygene-calibration-box.component';
import { PHCalibrationBoxComponent } from 'src/app/tools/ui/pH-calibration-box/pH-calibration-box.component';
import { SondeBoxComponent } from 'src/app/tools/ui/sonde-box/sonde-box.component';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-metrologie',
    templateUrl: './metrologie.component.html',
    styleUrls: ['./metrologie.component.scss']
})
export class MetrologieComponent implements OnInit, AfterViewInit, AfterViewChecked {
    // @ViewChild("tile", {static: false}) tile;
    // @ViewChild("tileadd") tileadd;
    SondeList: MasterSonde[] = [];

    constructor(
        private coreData: CoreData,
        private masterSondeService: MasterSondeService,
        private ajustageContexteService: AjustageContexteService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar) { }

    ngAfterViewChecked(): void {
        // this.getTileSize();
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.getAllSonde();
        this.coreData.CurrentPageName = "";
    }

    getBackgroundColorBySondeType(type: EMasterSondeType) {
        switch (type) {
            case EMasterSondeType.Conductivite:
                return '#F5822B !important';
            case EMasterSondeType.Oxygene:
                return '#FFDD4A !important';
            case EMasterSondeType.PH:
                return '#3AB795 !important';
        }
    }

    getTextColorBySondeType(type: EMasterSondeType) {
        switch (type) {
            case EMasterSondeType.Conductivite:
                return 'white !important';
            case EMasterSondeType.Oxygene:
                return 'black !important';
            case EMasterSondeType.PH:
                return 'white !important';
        }
    }

    async getAllSonde() {
        this.SondeList = await this.masterSondeService.getAllSonde().toPromise();
    }

    getSondeTypeLabel(type: EMasterSondeType) {
        return StringConverter.getMasterSondeTypeName(type);
    }

    openSondeDialog(sonde?: MasterSonde) {
        const dialogRef = this.dialog.open(SondeBoxComponent, {
            data: sonde,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: MasterSonde) => {
            if (result) {
                if (result.Code) {
                    this.updateSonde(result);
                    sonde.FacteurCorrection = result.FacteurCorrection;
                    sonde.Type = result.Type;
                } else {
                    this.createSonde(result);
                    this.SondeList.push(result)
                }
            }
        });
    }

    // getTileSize() {
    //     // return  `${document.getElementById('tile')?.clientHeight} !important`;
    //     if (this.tile && this.tileadd) {
    //         var height = `${this.tile.nativeElement.offsetHeight}px`;
    //         this.renderer.setStyle(this.tileadd.nativeElement, "min-height", height);
    //     }
    // }
    openCalibration(sonde: MasterSonde) {
        switch (sonde.Type) {
            case EMasterSondeType.Conductivite:
                this.openConductiviteCalibration(sonde)
                break;
            case EMasterSondeType.Oxygene:
                this.openOxygeneCalibration(sonde)
                break;
            case EMasterSondeType.PH:
                this.openPHCalibration(sonde)
                break;
        }
    }

    openOxygeneCalibration(sonde: MasterSonde) {
        const dialogRef = this.dialog.open(OxygeneCalibrationBoxComponent, {
            data: sonde,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: AjustageContexte) => {
            if (result) {
                sonde.AjustageContexteList.push(result)
                this.updateAjustageContexte(result, sonde.Code)
            }
        });
    }

    openConductiviteCalibration(sonde: MasterSonde) {
        const dialogRef = this.dialog.open(ConductiviteCalibrationBoxComponent, {
            data: sonde.Reference,
            width: '1200px',
            maxHeight: '600px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: AjustageContexte) => {
            if (result) {
                if (sonde.AjustageContexteList.length === 0)
                    sonde.AjustageContexteList.push(result)
                else
                    sonde.AjustageContexteList[0] = result

                this.updateAjustageContexte(result, sonde.Code)
            }
        });
    }

    openPHCalibration(sonde: MasterSonde) {
        const dialogRef = this.dialog.open(PHCalibrationBoxComponent, {
            data: sonde.Reference,
            width: '999px',
            maxHeight: '600px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: AjustageContexte) => {
            if (result) {
                if (sonde.AjustageContexteList.length === 0)
                    sonde.AjustageContexteList.push(result)
                else
                    sonde.AjustageContexteList[0] = result

                this.updateAjustageContexte(result, sonde.Code)
            }
        });
    }

    openHistory(sonde: MasterSonde) {
        const dialogRef = this.dialog.open(HistoryBoxComponent, {
            data: sonde.Reference,
            width: '999px',
            maxHeight: '800px',
            disableClose: true
        });

    }

    updateAjustageContexte(ajustageContexte: AjustageContexte, sondeCode: string) {
        this.ajustageContexteService.update(ajustageContexte, sondeCode).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Calibration correctement modifiée !', this.snackBar);
            }
        })
    }

    updateSonde(sonde: MasterSonde) {
        this.masterSondeService.update(sonde).subscribe(x => {
            if (x)
                NotificationManager.handleSuccess('Sonde correctement modifiée !', this.snackBar);
        })
    }

    createSonde(sonde: MasterSonde) {
        this.masterSondeService.create(sonde).subscribe(x => {
            if (x)
                NotificationManager.handleSuccess('Sonde correctement ajoutée !', this.snackBar);
        })
    }

    deleteSonde(sonde: MasterSonde) {
        this.masterSondeService.toggleIsActive(sonde).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess(`Sonde correctement ${sonde.IsActive ? 'désactivée' : 'activée'} !`, this.snackBar);
                sonde.IsActive = !sonde.IsActive;
            }
        })
    }
}
